import { useToast } from '@airship-platform/airship-patterns';
import { FileButton } from '@airship-platform/jam-web/components';
import { CameraIcon } from '@airship-platform/jam-web/icons';
import { useAppointmentProposalFiles } from '../../../../data-access/appointmentProposalFiles';

const exceptedFiles = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/jpg',
  'video/mpeg',
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'video/x-msvideo',
  'application/pdf',
];

const MediaCapture: React.FC = () => {
  const { showToast } = useToast();
  const { isLoading, uploadAppointmentFiles } = useAppointmentProposalFiles();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const validFiles = Array.from(event.target.files || []).filter((file) =>
      exceptedFiles.includes(file.type)
    );

    if (!validFiles.length) {
      showToast('Please upload an image or video', 'warning');
    }

    uploadAppointmentFiles(validFiles, 'EXISTING_SYSTEM');
  };

  return (
    <FileButton
      fullWidth
      multiple
      acceptedFiles={exceptedFiles.join(',')}
      startIcon={<CameraIcon />}
      onChange={handleFileChange}
      isLoading={isLoading}
    >
      Upload Files
    </FileButton>
  );
};

export default MediaCapture;
